// General
export const backgroundColor = '#FFFFFF'
export const accentPrimary = '#919163'
export const accentSecondary = '#FAF9F7'

// Elements
export const textColorDark = '#4A3C31'
export const textColorLight = '#FFFFFF'
export const linkAccent = '#FFA700'
export const linkHoveredAccent = '#FFC400'
export const headerColor = '#4A3C31'
export const footerColor = '#5F5F3C'
export const lightBorderAccent = '#707070'
export const lightMetaAccent = '#8E8E8E'

// Sections
export const sectionAccentLight = '#B8A30A'
export const sectionAccentMed = '#6E8B0C'
export const sectionAccentDark = '#547403'
export const formAccent = '#EDECE7'
